import {HTMLAttributes} from 'react';

import styled from 'styled-components';

import {MarginProps, PaddingProps, generateMargins, generatePadding} from 'utils/components';

interface Props {
  alignItems?: string;
  flexDirection?: string;
  flexBasis?: string;
  flexGrow?: number;
  flexWrap?: string;
  justifyContent?: string;
  gap?: string;
}

type StyledProps = HTMLAttributes<HTMLDivElement> & Props & MarginProps & PaddingProps;

export const Flex = styled.div<StyledProps>`
  align-items: ${(props: StyledProps) => props.alignItems || 'stretch'};
  display: flex;
  flex-direction: ${(props: StyledProps) => props.flexDirection || 'row'};
  justify-content: ${(props: StyledProps) => props.justifyContent || 'flex-start'};
  flex-wrap: ${(props: StyledProps) => props.flexWrap || 'nowrap'};
  flex-grow: ${(props: StyledProps) => props.flexGrow || 0};
  flex-basis: ${(props: StyledProps) => props.flexBasis || 'auto'};
  gap: ${(props: StyledProps) => props.gap || 'normal'};
  ${(props: StyledProps) => generateMargins(props)}
  ${(props: StyledProps) => generatePadding(props)}
`;
